import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ResultDeviceInfo } from '../interfaces/DeviceIf'
import { useAuth } from './useAuth'

interface C213DeviceGetProps {
  execDeviceGet: (tenant: string) => Promise<ResultDeviceInfo>
  loading: loadStatus
}

const DEVICE_GET_DEDUPE_MS = 1500
const deviceGetInFlight = new Map<string, Promise<ResultDeviceInfo>>()
const deviceGetRecent = new Map<string, { expiresAt: number; result: ResultDeviceInfo }>()

// C213 テナント配下デバイス取得API呼出
export const useC213DeviceGet = (): C213DeviceGetProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()

  const execDeviceGet = async (tenant: string) => {
    const cached = deviceGetRecent.get(tenant)
    if (cached && cached.expiresAt > Date.now()) {
      return cached.result
    }

    const inFlight = deviceGetInFlight.get(tenant)
    if (inFlight) {
      return inFlight
    }

    const requestPromise = (async (): Promise<ResultDeviceInfo> => {
      try {
        setLoading(loadStatus.LOADING)
        const jwt = await auth.getJwt()
        if (jwt === '') {
          //return { success: false, message: errorMsg.SESSION_ERROR }
        }

        const header = Object.assign(axiosDefaultHeader, {
          Authorization: 'Bearer ' + jwt,
        })

        const response = await axios.get(
          `${baseUrl}${stage}${apiUrl.tenantsPath}${tenant}${apiUrl.devicesPath}`,
          {
            headers: header,
            validateStatus: () => true,
          },
        )

        if (response.status === apiStatus.SUCCESS) {
          return { success: true, info: response.data }
        }

        if (response.data && response.data.message) {
          return { success: false, message: response.data.message }
        }
        return { success: false, message: errorMsg.SYSTEM_ERROR }
      } catch (error) {
        return { success: false, message: errorMsg.SYSTEM_ERROR }
      } finally {
        setLoading(loadStatus.LOADED)
      }
    })()

    deviceGetInFlight.set(tenant, requestPromise)

    try {
      const result = await requestPromise
      deviceGetRecent.set(tenant, {
        expiresAt: Date.now() + DEVICE_GET_DEDUPE_MS,
        result,
      })
      return result
    } finally {
      deviceGetInFlight.delete(tenant)
    }
  }

  return { execDeviceGet, loading }
}
